import { DASHBOARD_CONFIG_DICT } from "./constants";

export function getBoardId(boardId) {
    return boardId || "all";
}

export function getBoard(boardId = "all") {
    return DASHBOARD_CONFIG_DICT[boardId];
}

export function constructUrlQueryParams(boardId = "all") {
    return `status=${boardId}`;
}

export function constructBoardUrl(baseUrl, boardId) {
    const queryParams = constructUrlQueryParams(boardId);
    const queryParamsString = !queryParams ? "" : `?${queryParams}`;
    return `${baseUrl}${queryParamsString}`;
}

export function constructWevosUrl(teamId, boardId) {
    const board = getBoard(boardId);
    const queryParams = `status=${board.queryString}`;
    const queryParamsString = !queryParams ? "" : `?${queryParams}`;
    return `/api/v1/teams/${teamId}/wevos${queryParamsString}`;
}

export function constructWevosRoute(teamId, boardId) {
    const queryParams = constructUrlQueryParams(boardId);
    const queryParamsString = !queryParams ? "" : `?${queryParams}`;
    return `/team/${teamId}/dashboard${queryParamsString}`;
}



// WEBPACK FOOTER //
// ./src/modules/wevos/utils.js